import $ from 'jquery';
import autostartFullScreenVideo from '../../Widgets/ui/autostartFullScreenVideo';
import checkEnableInput from '../../Widgets/ui/checkEnableInput';
import immersiveVideo from '../../Widgets/ui/immersiveVideo';
import editorFactory from '../../Widgets/Wysiwyg/editorFactory';
import autocomplete from '../../Widgets/autocomplete';
import choiceForm from '../../Widgets/ui/choiceForm';
import ajaxUpload from '../../Widgets/ui/ajaxUpload';
import socialButtons from '../../Widgets/ui/socialButtons';

const widgets = [
  {
    name: 'autostartFullScreenVideo',
    widget: autostartFullScreenVideo,
  },
  {
    name: 'checkEnableInput',
    widget: checkEnableInput,
  },
  {
    name: 'immersiveVideo',
    widget: immersiveVideo,
  },
  {
    name: 'wysiwyg',
    widget: editorFactory,
  },
  {
    name: 'autocomplete',
    widget: autocomplete,
  },
  {
    name: 'choiceForm',
    widget: choiceForm,
  },
  {
    name: 'ajaxUpload',
    widget: ajaxUpload,
  },
  {
    name: 'socialButtons',
    widget: socialButtons,
  },
];

export default {
  name: 'uiWidgetInitializer',
  init: function () {
    widgets.forEach(({ name, widget }) => {
      $('.js-' + name).each(function (n, element) {
        try {
          widget.create(element);
        } catch (e) {
          /* */
        }
      });
    });
  },
};
